<template>
  <div v-if="isLoaded">
    <div
      class="content-body"
      v-bind:class="{ fullscreen_expand: isFullscreen }"
    >
      <div class="row match-height">
        <div class="col-xl-12 col-lg-12">
          <div class="card" style="">
            <div class="card-header">
              <h4 class="card-title">Posição de Notas Fiscais</h4>
              <a class="heading-elements-toggle"
                ><i class="fa fa-ellipsis-v font-medium-3"></i
              ></a>
              <div class="heading-elements">
                <ul class="list-inline mb-0">
                  <li>
                    <a
                      @click="onFilterReset()"
                      v-b-tooltip
                      title="Atualizar listagem"
                      ><i class="ft-rotate-cw"></i
                    ></a>
                  </li> 
                  <li>
                    <a @click="onFilterReset()" v-b-tooltip title="Atualizar listagem"><i class="ft-rotate-cw"></i></a>
                  </li>
                  <li>
                    <a @click="expandFullscreenFw()" v-b-tooltip title="Expande a tela" v-if="!isFullscreen"><i
                        class="ft-maximize"></i></a>
                  </li>
                  <li>
                    <a
                      @click="expandFullscreenFw()"
                      v-b-tooltip
                      title="Minimiza a tela"
                      v-if="isFullscreen"
                      ><i class="ft-minimize"></i
                    ></a>
                  </li>
                  <li>
                    <a
                      @click="expandFullscreenFw()"
                      v-b-tooltip
                      title="Minimiza a tela"
                      v-if="isFullscreen"
                      ><i class="ft-minimize"></i
                    ></a>
                  </li>
                  <li>
                    <a
                      @click="onFilterShowHideFw()"
                      v-b-tooltip.hover.left="'Filtros'"
                      ><i class="fa fa-filter"></i
                    ></a>
                  </li>
                </ul>
              </div>
            </div>
            <div class="card-content">
              <div class="table-responsive">
                <div v-if="vuetableFilterRow">
                  <vuetable-filterbar :tabela="'veiculo'"> </vuetable-filterbar>
                </div>
                <div class="loadingDataPosition">
                  <div class="loadingData" v-if="loadingData">
                    <div class="loadingDataSpinner">
                      <spinner
                        v-if="loadingData"
                        text-fg-color="#ffffff"
                        message="Carregando..."
                      ></spinner>
                    </div>
                  </div>
                  <vuetable
                    ref="vuetable"
                    api-url="/api/posicaonotafiscal"
                    :fields="fields"
                    :css="css"
                    :append-params="moreParams"
                    track-by="docfisId"
                    pagination-path="meta"
                    detail-row-component="posicao-detalhes"
                    @vuetable:cell-clicked="onDetail"
                    @vuetable:load-error="onError"
                    @vuetable:pagination-data="onPaginationData"
                    @vuetable:loaded="onLoaded"
                  >
                    <template slot="num_controle" slot-scope="props">
                      <span v-if="
                        props.rowData.cargaDoc != null &&
                        props.rowData.cargaDoc.docCargaDoc &&
                        props.rowData.cargaDoc.docCargaDoc.doc != null &&
                        props.rowData.cargaDoc.docCargaDoc.doc.docCte != null &&
                        props.rowData.cargaDoc.docCargaDoc.doc.docCte
                          .statusSefazValor != null
                      ">
                        <span v-b-tooltip :title="defineCte(props.rowData, 1)">
                          {{ defineCte(props.rowData, 2) }}
                        </span>
                      </span>
                      <span v-if="
                        props.rowData.cargaDoc != null &&
                        props.rowData.cargaDoc.docCargaDoc != null &&
                        props.rowData.cargaDoc.docCargaDoc.doc != null &&
                        props.rowData.cargaDoc.docCargaDoc.doc.docCte == null
                      ">
                        {{ props.rowData.cargaDoc.docCargaDoc.doc.numControle }}
                      </span>
                    </template>
                    <template slot="num_carga" slot-scope="props">
                      <span v-if="props.rowData.cargaBipDocUltima != null">
                        <span
                          v-b-tooltip
                          :title="
                            props.rowData.cargaBipDocUltimaStatusCargaValor == 2
                              ? 'Em andamento'
                              : props.rowData
                                  .cargaBipDocUltimaStatusCargaValor == 6
                              ? 'Pendente'
                              : props.rowData.cargaBipDocUltimaStatusCargaDescr
                          "
                        >
                          {{
                            props.rowData.cargaBipDocUltima
                              .cargaBipDocUltimaNumCarga
                          }}
                        </span>
                      </span>
                      <span v-if="
                        props.rowData.cargaBipDocUltima == null && 
                        props.rowData.cargaDoc != null &&
                        props.rowData.cargaDoc.docCargaDoc != null && 
                        props.rowData.cargaDoc.docCargaDoc.doc != null &&
                        props.rowData.cargaDoc.docCargaDoc.doc.tpProcesso.valor == 6">
                        {{ props.rowData.cargaDoc.carga.numCarga }}
                      </span>
                    </template>
                    <template slot="motorista" slot-scope="props">
                      <span
                        v-if="
                          props.rowData.cargaDoc != null &&
                          props.rowData.cargaDoc.carga.cargaMeioTransp !=
                            null &&
                          props.rowData.cargaDoc.carga.cargaMeioTransp
                            .nomeMotorista != null
                        "
                        ><span
                          v-b-tooltip
                          :title="
                            props.rowData.cargaDoc.carga.pessoa.pessoaJuridica
                              .razaoSocial
                          "
                        >
                          {{
                            props.rowData.cargaDoc.carga.cargaMeioTransp
                              .nomeMotorista
                          }}
                        </span>
                      </span>
                    </template>
                    <template slot="doc_saida" slot-scope="props">
                      <span
                        v-if="
                          props.rowData.cargaDoc != null &&
                          props.rowData.cargaDoc.carga != null &&
                          props.rowData.cargaDoc.carga.manifesto != null &&
                          props.rowData.cargaDoc.carga.tpOperacaoPrincipal == 2
                        "
                        ><span v-b-tooltip title="Manifesto">
                          {{ props.rowData.cargaDoc.carga.manifesto.numFiscal }}
                        </span>
                      </span>
                      <span
                        v-if="
                          props.rowData.cargaDoc != null &&
                          props.rowData.cargaDoc.carga != null &&
                          props.rowData.cargaDoc.carga.status.valor == 3 &&
                          props.rowData.cargaDoc.carga.tpOperacaoPrincipal == 3
                        "
                        ><span v-b-tooltip title="Romaneio">
                          {{ props.rowData.cargaDoc.carga.numCarga }}
                        </span>
                      </span>
                    </template>
                    <template slot="placa" slot-scope="props">
                      <span
                        v-if="
                          props.rowData.cargaDoc != null &&
                          props.rowData.cargaDoc.carga.cargaMeioTransp !=
                            null &&
                          props.rowData.cargaDoc.carga.cargaMeioTransp.placa !=
                            null
                        "
                        >{{
                          props.rowData.cargaDoc.carga.cargaMeioTransp.placa
                        }}</span
                      >
                    </template>
                    <template slot="redespacho" slot-scope="props">
                      <span
                        v-if="
                          props.rowData.docFiscalPartesEnv.redNome != null &&
                          props.rowData.docFiscalPartesEnv
                            .pessoaJuridicaRedespacho == null
                        "
                        v-b-tooltip
                        :title="
                          ajustaMascara(
                            props.rowData.docFiscalPartesEnv.redCnpj
                          )
                        "
                        >{{ props.rowData.docFiscalPartesEnv.redNome }}</span
                      >
                      <span
                        v-b-tooltip
                        :title="
                          ajustaMascara(
                            props.rowData.docFiscalPartesEnv.redCnpj
                          )
                        "
                        v-if="
                          props.rowData.docFiscalPartesEnv
                            .pessoaJuridicaRedespacho != null
                        "
                        ><strong>{{
                          props.rowData.docFiscalPartesEnv
                            .pessoaJuridicaRedespacho.cd
                        }}</strong>
                        -
                        {{
                          props.rowData.docFiscalPartesEnv
                            .pessoaJuridicaRedespacho.descr
                        }}</span
                      >
                    </template>
                    <template slot="parceira" slot-scope="props">
                      <span
                        v-if="
                          props.rowData.cargaDoc != null &&
                          props.rowData.cargaDoc.carga.pessoaParceira != null &&
                          props.rowData.cargaDoc.carga.pessoaParceira.pessoa
                            .pessoaJuridica != null
                        "
                        v-b-tooltip
                        :title="
                          ajustaMascara(
                            props.rowData.cargaDoc.carga.pessoaParceira.pessoa
                              .pessoaJuridica.cnpj
                          )
                        "
                        >{{
                          props.rowData.cargaDoc.carga.pessoaParceira.pessoa
                            .pessoaJuridica.razaoSocial
                        }}</span
                      >
                      <span
                        v-if="
                          props.rowData.cargaDoc != null &&
                          props.rowData.cargaDoc.carga.pessoaParceira != null &&
                          props.rowData.cargaDoc.carga.pessoaParceira.pessoa
                            .pessoaFisica != null
                        "
                        v-b-tooltip
                        :title="
                          props.rowData.cargaDoc.carga.pessoaParceira.pessoa
                            .pessoaFisica.cpf
                        "
                        >{{
                          props.rowData.cargaDoc.carga.pessoaParceira.pessoa
                            .pessoaFisica.nome
                        }}</span
                      >
                    </template>
                    <template slot="dt_expedicao" slot-scope="props">
                      <span v-if="props.rowData.cargaDoc != null">
                        {{
                          formatDate(props.rowData.cargaDoc.carga.dtExpedicao)
                        }}
                      </span>
                    </template>
                    <template slot="dt_previsao" slot-scope="props">
                      <span v-if="props.rowData.dtPrevisao != null">
                        {{
                          formatDate(props.rowData.dtPrevisao, "DD/MM/YYYY")
                        }}
                      </span>
                    </template>
                    <template slot="des_regiao" slot-scope="props">
                      <span
                        v-if="props.rowData.docFiscalPartesEnv != null && props.rowData.docFiscalPartesEnv.desRegiao != null">
                        {{ props.rowData.docFiscalPartesEnv.desRegiao.cd }} | {{
                        props.rowData.docFiscalPartesEnv.desRegiao.descr }}
                      </span>
                    </template>
                    <template slot="actions" slot-scope="props">
                      <div class="custom-actions">
                        <a
                          @click="onDetail(props.rowData, null, null)"
                          v-b-tooltip
                          v-if="props.rowData.cargaDoc != null"
                          title="Ver detalhes"
                          ><i class="fa fa-plus"></i
                        ></a>
                      </div>
                    </template>
                  </vuetable>
                </div>
                <div>
                  <div class="col-emd-12">
                    <div class="pull-left pagination-detail">
                      <vuetable-pagination-info
                        ref="paginationInfo"
                        :css="css.pagination"
                        info-class="pull-left"
                      ></vuetable-pagination-info>
                    </div>
                    <div class="pull-right m-a-0">
                      <vuetable-pagination
                        ref="pagination"
                        :css="css.pagination"
                        @vuetable-pagination:change-page="onChangePage"
                      ></vuetable-pagination>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Vuetable from "../components/Vuetable";
import VuetablePagination from "../components/VuetablePagination";
import VuetablePaginationInfo from "../components/VuetablePaginationInfo";
import PosicaoNotaFiscalFilterBar from "./PosicaoNotaFiscalFilterBar";
import PosicaoNotaFiscalDetalhes from "./PosicaoNotaFiscalDetalhes";
import accounting from "accounting";
import moment from "moment";

Vue.component("posicao-detalhes", PosicaoNotaFiscalDetalhes);

export default {
  components: {
    Vuetable,
    VuetablePagination,
    VuetablePaginationInfo,
    PosicaoNotaFiscalDetalhes,
    "vuetable-filterbar": PosicaoNotaFiscalFilterBar,
  },
  data() {
    return {
      dataExport: [],
      optionsVeiculo: [],
      optionsUnidade: [],
      helpForm: new Form({ recordCollection: [], status: "" }),
      formimprimir: new Form({
        doc_id: "",
        doc_id_pdf: [],
        doccte_id: "",
        docrps_id: "",
        tp_doc: "",
        tp_print: "",
      }),
      modal_titulo: "",
      modal_botao: "",
      modal_acao: "",
      loading: false,
      isDisabled: false,
      loadingData: true,
      showModal: false,
      isLoadingExp: false,
      fields: [
        {
          name: "__checkbox",
          titleClass: "center aligned",
          dataClass: "center aligned",
        },
        {
          name: "numFiscal",
          title: "N° NF",
        },
        {
          name: "serie",
          title: "Serie NF",
        },
        {
          name: "__slot:num_carga",
          title: "N° Carga",
        },
        {
          name: "__slot:num_controle",
          title: "N° Controle",
        },
        {
          name: "__slot:doc_saida",
          title: "Doc. Saída",
        },
        {
          name: "__slot:dt_expedicao",
          title: "Data Expedição",
        },
        {
          name: "__slot:dt_previsao",
          title: "Data Previsão",
        },
        {
          name: "docFiscalPartesEnv.emiNome",
          title: "Emissor NFe",
        },
        {
          name: "docFiscalPartesEnv.desNome",
          title: "Destinatário",
        },
        {
          name: "docFiscalPartesEnv.desNomeMunicipio",
          title: "Destino",
        },
        {
          name: "__slot:redespacho",
          title: "Redespacho",
        },
        {
          name: "__slot:parceira",
          title: "Parceira",
        },
        {
          name: "__slot:motorista",
          title: "Motorista",
        },
        {
          name: "__slot:placa",
          title: "Placa principal",
        },
        // {
        //   name: "__slot:status",
        //   title: "Status",
        // },
        {
          name: "__slot:actions",
          title: "Ações",
          titleClass: "center aligned",
          dataClass: "center aligned",
        },
      ],
      css: {
        loadingClass: "loading",
        ascendingIcon: "glyphicon glyphicon-chevron-up",
        descendingIcon: "glyphicon glyphicon-chevron-down",
        handleIcon: "glyphicon glyphicon-menu-hamburger",
      },
      moreParams: {},
    };
  },
  mounted() {
    this.$events.$on("filter-set-posicaonf", (eventData) =>
      this.onFilterSet(eventData)
    );
    this.$events.$on("filter-reset-posicaonf", (e) => this.onFilterReset());
    this.getLivGeral();
  },
  methods: {
    onDetail(data, field, event) {
      if (data) {
        this.$refs.vuetable.toggleDetailRow(data.docfisId);
      }
    },
    onPaginationData(paginationData) {
      this.$refs.pagination.setPaginationData(paginationData);
      this.$refs.paginationInfo.setPaginationData(paginationData);
    },
    onChangePage(page) {
      this.$refs.vuetable.changePage(page);
    },
    formatNumber(value) {
      return accounting.formatNumber(value, 2, ".", ",");
    },
    getLivGeral() {
      this.helpForm
        .get("/api/posicaonotafiscal/jsonlistgeral")
        .then((response) => {
          new ReturnApi(response, this, true, false, false);
          response.unidade.forEach((obj) => {
            this.optionsUnidade.push({
              label: obj.cd + " - " + obj.descr,
              value: obj.unidade_id,
            });
          });
          response.veiculo.forEach((obj) => {
            this.optionsVeiculo.push({
              label: obj.placa,
              value: obj.veiculo_id,
            });
          });
        })
        .catch((errors) => {
          new ReturnApi(errors, this);
        });
    },
    onFilterSet(data_filter) {
      this.loadingData = true;
      this.moreParams = {
        num_fiscal: data_filter.num_fiscal,
        num_carga: data_filter.num_carga,
        dt_inicio_expedicao: data_filter.dt_inicio_expedicao,
        dt_fim_expedicao: data_filter.dt_fim_expedicao,
        dt_emissao_nf_ini: data_filter.dt_emissao_nf_ini,
        dt_emissao_nf_fim: data_filter.dt_emissao_nf_fim,
        num_fiscal_doc_ini: data_filter.num_fiscal_doc_ini,
        num_fiscal_doc_fim: data_filter.num_fiscal_doc_fim,
        num_fiscal_mdfe: data_filter.num_fiscal_mdfe,
        razao_social_red: data_filter.razao_social_red,
        cnpj_red: data_filter.cnpj_red,
        dt_emi_doc_ini: data_filter.dt_emi_doc_ini,
        dt_emi_doc_fim: data_filter.dt_emi_doc_fim,
        dt_previsao_ini: data_filter.dt_previsao_ini,
        dt_previsao_fim: data_filter.dt_previsao_fim,
        razao_social_rem: data_filter.razao_social_rem,
        cnpj_rem: data_filter.cnpj_rem,
        veiculo: data_filter.veiculo.value,
        unidade: data_filter.unidade.value,
        fornecedor: data_filter.fornecedor.value,
      };
      Vue.nextTick(() => {
        this.$refs.vuetable.refresh();
      });
    },
    onFilterReset() {
      this.loadingData = true;
      this.moreParams = {};
      Vue.nextTick(() => this.$refs.vuetable.refresh());
    },
    onLoaded: function () {
      this.dataExport = this.$refs.vuetable.tableData;
      this.loadingData = false;
      this.$store.commit("setVuetableFilterButton", false);
    },
    formatDate(value, fmt = "DD/MM/YYYY HH:mm") {
      return value == null ? "" : moment(value, "YYYY-MM-DD HH:mm").format(fmt);
    },
    ajustaMascara(data) {
      if (data != null) {
        if (data.length == 11) {
          //cpf
          return data.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
        }
        if (data.length == 14) {
          //cnpj
          return data.replace(
            /(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/,
            "$1.$2.$3/$4-$5"
          );
        }
      }
    },
    defineCte(data, tipo) {
      this.tooltip_doc = "";
      this.descr_grid_doc = "";
      data.cargaDocReentrega.forEach((obj) => {
        if (obj.docCargaDoc != null && obj.docCargaDoc.doc.tpDoc.valor == 1) {
          if (obj.docCargaDoc.doc.docCte.statusSefaz.valor == 4) {
            this.tooltip_doc = obj.docCargaDoc.doc.docCte.statusSefaz.descr;
            this.descr_grid_doc = obj.docCargaDoc.doc.numControle;
          }
        } else {
          this.tooltip_doc = "";
          this.descr_grid_doc = data.cargaDoc.docCargaDoc.doc.numControle;
        }
      });
      //1 = Tooltip | 2 = grid
      if (tipo == 1) {
        return this.tooltip_doc;
      } else {
        return this.descr_grid_doc;
      }
    },
    onError(errors) {
      // new ReturnApi(response, this, true, true, false);
      new ReturnApi(errors, this, true, null, null, false);

      var errors = errors.response.data.errors;

      this.errors_array = "";
      this.errors_array = [];
      this.form.unidades = [];
      for (var property in errors) {
        if (errors.hasOwnProperty(property)) {
          if (typeof errors[property] === "object") {
            errors[property].forEach((obj) => {
              this.errors_array.push({
                erro: obj,
              });
            });
          }
        }
      }
      console.log(this.errors_array);
    },
  },
  computed: {
    vuetableFilterRow: {
      get() {
        return this.$store.state.vuetable.filterRow;
      },
    },
    isLoaded: {
      get() {
        return this.$store.getters.isloaded;
      },
    },
    isFullscreen: {
      get() {
        return this.$store.getters.is_full_screen;
      },
    },
  },
};
</script>